<template>
  <div>
    <slide-in direction="left">
      <branded-box class="get-in-touch">
        <h1>Get in touch</h1>
        <p>If you are interested in any of our services, have some questions, or if you think that we can help you to fulfil your transport needs, then please get in touch with us as soon as possible.</p>
        <p>You can use the contact form below, or feel free to give us a phone call on <span><svg-icon icon="phone" /> 01795 665214</span></p>
      </branded-box>
    </slide-in>

    <text-and-image class="contact" reversed>
      <template v-slot:image>
        <img src="../assets/contact_us.jpg" alt="People answering phones">
      </template>
      <template v-slot:header>Contact Form</template>
      <template v-slot:text>
        <form class="contact__form" onsubmit="return false">

          <div class="contact__form-group">
            <label for="name">Your name</label>
            <input id="name" type="text" v-model="name"/>
          </div>

          <div class="contact__form-group">
            <label for="email">Your email address</label>
            <input id="email" type="email" v-model="email"/>
          </div>

          <div class="contact__form-group">
            <label for="phone">Your phone number</label>
            <input id="phone" type="tel" v-model="phone"/>
          </div>

          <div class="contact__form-group">
            <label for="org">Your organisation</label>
            <input id="org" type="text" v-model="organisation"/>
          </div>

          <div class="contact__form-group about">
            <label for="about">I'm contacting you about</label>
            <select id="about" v-model="subject">
              <option>Refrigerated Transport</option>
              <option>Container Transport</option>
              <option>Personal Storage</option>
              <option>On Site Parking</option>
              <option>Jobs</option>
              <option>Something Else</option>
            </select>
          </div>

          <div class="contact__form-group message">
            <label for="message">Message</label>
            <textarea id="message" v-model="message"> </textarea>
          </div>

          <button class="branded-button" @click="send">Send</button>
        </form>
      </template>

    </text-and-image>
  </div>
</template>
<script>
  import BrandedBox from "../components/branded-box";
  import SlideIn from "../components/slide-in";
  import TextAndImage from "../components/text-and-image";
  import "../assets/icons/phone"
  export default {
    components: {TextAndImage, SlideIn, BrandedBox},
    data() {
      return {
        name: null,
        email: null,
        phone: null,
        organisation: null,
        subject: null,
        message: null,
      }
    },
    methods: {
      async send() {

        const response = await fetch(process.env.VUE_APP_CONTACT_FORM_URL,{
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            name: this.name,
            email: this.email,
            phone: this.phone,
            organisation: this.organisation,
            subject: this.subject,
            message: this.message,
          })
        });

        if(response.status === 200) {
          this.name = null;
          this.email = null;
          this.phone = null;
          this.organisation = null;
          this.subject = null;
          this.message = null;

          this.flashSuccess('Thank you for your submission. We\'ll  be in touch shortly.')

        } else {
          this.flashError('Sorry, something has gone wrong.')
        }

      }
    }
  }
</script>

<style lang="scss" scoped>

  .get-in-touch {
    padding: 1rem;
  }

  .contact {
    margin-top: 1rem;

    &__form {
      display: flex;
      flex-flow: row wrap;

      &-group {
        width: calc(50% - 0.5rem);
        margin-top: 1rem;
        padding:0.25rem;

        label {
          display: block;
        }
        input, textarea, select {
          box-sizing: border-box;
          width: 100%;
          height: 2rem;
          border-radius: 0.5rem;
        }

        textarea {
          height: 5rem;
        }
      }

     }


    input {
      line-break: anywhere;
    }
  }

  .subject, .message, .about {
    width: 100%;
  }

</style>